import { jsx, jsxs } from 'react/jsx-runtime';
import { IconArrowLeftOutline, IconXSolid } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { Heading } from '../../Heading/Heading.es.js';
import { useInternalSideSheetContext } from '../SideSheet.Context/index.es.js';

const SideSheetHeader = ({ title, children: subtitle, locale, disableNav = false })=>{
    const { hideBack, variant, onBack, onClose } = useInternalSideSheetContext();
    return jsx("div", {
        className: classNames('cb-side-sheet-header'),
        "data-testid": "side-sheet-header",
        children: jsxs("div", {
            className: classNames('cb-side-sheet-header-content', variant),
            "data-testid": "side-sheet-header-content",
            children: [
                jsxs("div", {
                    className: "cb-side-sheet-nav",
                    children: [
                        !hideBack && variant === 'default' && jsx(Button, {
                            disabled: disableNav,
                            label: locale?.back ?? 'Back',
                            onClick: onBack,
                            size: "sm",
                            variant: "secondary",
                            iconOnly: true,
                            children: jsx(IconArrowLeftOutline, {})
                        }),
                        jsx(Button, {
                            className: "cb-side-sheet-close",
                            disabled: disableNav,
                            label: locale?.close ?? 'Close',
                            onClick: onClose,
                            size: "sm",
                            variant: "secondary",
                            iconOnly: true,
                            children: jsx(IconXSolid, {})
                        })
                    ]
                }),
                title && jsxs(Heading, {
                    className: "cb-side-sheet-heading",
                    id: "side-sheet-title",
                    variant: variant === 'default' ? 'section/md' : 'title/md',
                    children: [
                        jsx(Heading.Header, {
                            children: title
                        }),
                        subtitle != null && jsx(Heading.Intro, {
                            children: subtitle
                        })
                    ]
                })
            ]
        })
    });
};
SideSheetHeader.displayName = 'SideSheet.Header';

export { SideSheetHeader };
//# sourceMappingURL=SideSheet.Header.es.js.map
